import React, { useState, useEffect } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

function TimeAgo({ children, interval = 60, className }) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!interval) return;
    const id = setInterval(() => setTick((t) => t + 1), interval * 1000);
    return () => clearInterval(id);
  }, [interval]);

  return <span className={className}>{dayjs(children).fromNow()}</span>;
}

export default TimeAgo;
